export default "<p>delegate-invitation-sent works!</p>\n"